import withMobile from 'hocs/withMobile/withMobile'
import { connectLoadable } from 'helpers/loadableHelpers'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { createSelector } from 'reselect'
import { Guards } from 'interfaces/guards'
import { redemptionItemsGuard } from 'guards/bountyGuards'
import { redemptionItemsAppSelector, redemptionItemsDataSelector } from 'selectors/bountySelectors'
import { getRedemptionsActionCreator } from 'actions/bountyActions'
import { getPageSizeProps, getPaginatorProps } from 'helpers/tableHelpers'
import RedemptionsModule, { RedemptionsModuleDispatchProps, RedemptionsModuleStateProps } from 'components/features/pfm/RedemptionsModule/RedemptionsModule'
import { SortingState } from 'interfaces/table'
import { MapDispatchToPropsFunction } from 'react-redux'

const createMapStateToProps = () =>
  createSelector(
    redemptionItemsDataSelector,
    redemptionItemsAppSelector,
    (redemptionItemsData, redemptionItemsApp): RedemptionsModuleStateProps => {
      if (!redemptionItemsData) {
        throw createForgottenGuardError('RedemptionsModuleContainer', 'redemptionItemsGuard')
      }

      const {
        isLoading,
        sorting,
      } = redemptionItemsApp

      const { results } = redemptionItemsData

      return {
        isLoading,
        rowsCollection: results,
        sorting,
        paginator: getPaginatorProps(redemptionItemsApp, redemptionItemsData),
        pageSize: getPageSizeProps(redemptionItemsApp),
      }
    }
  )

const mapDispatchToProps: MapDispatchToPropsFunction<RedemptionsModuleDispatchProps> = (dispatch) => ({
  onPageClick: (page: number) => dispatch(getRedemptionsActionCreator.request({ page })),
  onPageSizeClick: (pageSize: number) => dispatch(getRedemptionsActionCreator.request({ pageSize, page: 1 })),
  onSortingClick: (sorting: SortingState) => dispatch(getRedemptionsActionCreator.request({ sorting })),
})

const guards: Guards = [
  redemptionItemsGuard,
]

const RedemptionsModuleContainerInner = withMobile(RedemptionsModule)

const RedemptionsModuleContainer = connectLoadable<
  RedemptionsModuleStateProps,
  RedemptionsModuleDispatchProps
>(guards)(createMapStateToProps, mapDispatchToProps)(RedemptionsModuleContainerInner)

export default RedemptionsModuleContainer
